import GamblingHome from '@/pages/Gambling/GamblingHome.vue'
import GamblingCasino from '@/pages/Gambling/GamblingCasino.vue'
import GamblingBetting from '@/pages/Gambling/GamblingBetting.vue'
import GamblingAccount from '@/pages/Gambling/GamblingAccount.vue'

const gamblingRoutes = [
  {
    path: '/gambling',
    name: 'GamblingHome',
    component: GamblingHome,
  },
  {
    path: '/gambling/casino',
    name: 'GamblingCasino',
    component: GamblingCasino,
  },
  {
    path: '/gambling/betting',
    name: 'GamblingBetting',
    component: GamblingBetting,
  },
  {
    path: '/gambling/account',
    name: 'GamblingAccount',
    component: GamblingAccount,
  }
]

export default gamblingRoutes
